module.exports = __webpack_public_path__ + "img/icon-smart-tv.ef10970.svg";